import React, {useEffect} from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSearch} from "@fortawesome/free-solid-svg-icons";
import {ApprovalTabData} from "../components/approval-tab-data";
import img from '../assets/icons/ic-img.svg';
import {FILTER_INTERVAL, GET_DOCUMENT, PENGAJUAN, REJECTION_MAIL} from "../Constanta";
import {AuthContext, DataContext} from "../Context";
import ModalApproval from "../components/modal/modal-approval";
import {translateRequestType, translateRequestStatus} from "../Services";
import {day, month, year} from "../util";
import XLSX from "xlsx";
import * as FileSaver from 'file-saver';
import Swal from "sweetalert2";

const Approval = () => {
    const [dataContext, dataState] = React.useContext(DataContext);
    const [authContext, loginState] = React.useContext(AuthContext);

    const [data, setData] = React.useState({
        selectedMenu: 'all',
        content: [],
        approvalModal: false,
        dateFilter: 'all',
        approvalSearch: '',
        downloadableData: [],
    });

    useEffect(() => {
        if (dataState.dataPengajuanCustomer.length <= 0) {
            setTimeout(async () => {
                    await Pengajuan('GET', null);
                }, 1000
            )
        } else {
            setData({
                ...data,
                content: dataState.dataPengajuanCustomer
            })
        }
    }, []);

    const Pengajuan = async (method, requestBody) => {
        let url = `${PENGAJUAN}`;
        let payload = {
            method: method,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + await localStorage.getItem('userToken'),
            },
            body: requestBody ?
                JSON.stringify(requestBody)
                : null
        };
        // console.log(JSON.stringify(requestBody))
        fetch(url, payload).then((result) => {
            if (method === 'PUT') {
                if (result.status <= 201) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Success...',
                        text: 'Status Data Sukses Diubah',
                    })
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Data gagal diubah!',
                    })
                }
            } else {
                result.json().then(resultData => {
                    dataContext.setDataPengajuanCustomer(resultData);
                    setData({
                        ...data,
                        content: resultData,
                        downloadableData: resultData
                    })
                })
            }
        });
    }

    const SendEmail = (user_data) => {
        let url = `${REJECTION_MAIL}`;
        let payload = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                nik: user_data.nik,
                email: user_data.email,
                message: user_data.message
            })
        };
        fetch(url, payload).then(response => {
            console.log('Email sent to : ' + user_data.email);
        })
    }

    const onClickDocument = async (filename) => {
        let url = `${GET_DOCUMENT}/${filename}`
        let payload = {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + await localStorage.getItem('userToken'),
            }
        };
        fetch(url, payload).then(response => {
            response.arrayBuffer().then((buffer) => {
                const url = window.URL.createObjectURL(new Blob([buffer]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", filename); //or any other extension
                document.body.appendChild(link);
                link.click();
            })
        })
    }

    const action = async (requestBody) => {
        // 3:REJECT 4:APPROVE
        let submittedData = requestBody;
        submittedData = {
            id: requestBody.id,
            requestCode: requestBody.requestCode,
            createdDate: requestBody.createdDate,
            modifiedDate: new Date(),
            version: requestBody.version,
            requestType: requestBody.requestType,
            requestData: requestBody.requestData,
            requestCategory: {id: requestBody.requestCategory.id},
            requestStatus: {},
            requestJourneys: requestBody.requestJourneys,
            requestOtherData: [],
        }
        submittedData.requestData.city = '-'
        submittedData.requestJourneys.forEach((data) => {
            delete data.id;
        });
        await Swal.fire({
            title: 'Alasan Penolakan',
            input: 'select',
            inputOptions: {
                // '1': 'Dibuat',
                '2': 'Menunggu Persetujuan',
                '3': 'Ditolak',
                '4': 'Disetujui',
                '5': 'Proses cetak kartu',
                '6': 'Kartu jadi/siap',
                '7': 'Kartu diambil/diterima'
            },
            confirmButtonText: 'Ubah Pengajuan'
        }).then((response) => {
            if (response.isConfirmed) {
                if (response.value === '3') {
                    Swal.fire({
                        title: 'Alasan Penolakan',
                        input: 'text',
                        confirmButtonText: 'Tolak Pengajuan'
                    }).then((responseText) => {
                        if (responseText.isConfirmed) {
                            submittedData.requestStatus = {id: 3}
                            submittedData.requestOtherData.push({key: 'reject-reason', value: responseText.value});
                            Pengajuan('PUT', submittedData);
                            SendEmail({
                                nik: requestBody.requestData.identityNumber,
                                email: requestBody.requestData.emailAddress,
                                message: responseText.value
                            });
                        }
                    })
                } else {
                    delete submittedData.requestOtherData;
                    submittedData.requestStatus = {id: parseInt(response.value)}
                    Pengajuan('PUT', submittedData)
                }
            }
        })
    }

    const selectedMenu = (selected) => {
        return data.selectedMenu === selected ? "approval-tab-category-pile-selected" : "approval-tab-category-pile";
    }

    const changeMenu = (selected) => {
        let preFilteredData = dataState.dataPengajuanCustomer;

        if (selected.toUpperCase() !== 'ALL') {
            setData({
                ...data,
                content: preFilteredData.filter(x => x.requestType.toUpperCase() === selected.toUpperCase()),
                selectedMenu: selected,

            })
        } else {
            setData({
                ...data,
                content: dataState.dataPengajuanCustomer,
                selectedMenu: selected,

            })
        }
    }

    const onChangeDateDownload = (formName, formValue) => {
        let content = data.content;
        let filteredDate;
        switch (formValue) {
            case 'today':
                filteredDate = content.filter(x => x.createdDate.split('T')[0].split('-')[2] === day);
                break;
            case 'week':
                filteredDate = content.filter(x => x.createdDate.split('T')[0].split('-')[2] >= day - 7);
                break;
            case 'month':
                filteredDate = content.filter(x => x.createdDate.split('T')[0].split('-')[1] === month);
                break;
            case 'year':
                filteredDate = content.filter(x => x.createdDate.split('T')[0].split('-')[0] === year);
                break;
            default:
                filteredDate = data.content
                break;
        }
        setData({
            ...data,
            dateFilter: formValue,
            downloadableData: filteredDate
        })
    }

    const onSearchDaftarPelanggan = (event) => {
        let preFilteredData = dataState.dataPengajuanCustomer;
        if (event.key === 'Enter') {
            if (data.approvalSearch) {
                setData({
                    ...data,
                    content: preFilteredData.filter(x => x.requestData.identityNumber.toUpperCase().includes(data.approvalSearch.toUpperCase()) || x.requestData.fullName.toUpperCase().includes(data.approvalSearch.toUpperCase())),
                })
            } else {
                setData({
                    ...data,
                    content: preFilteredData,
                })
            }
        }
    }

    const downloadExcel = () => {
        let preparedData;
        if ((data.dateFilter === 'all') && (data.downloadableData.length <= 0)) {
            preparedData = data.content
        } else if (data.downloadableData.length <= 0) {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Tidak ada data di range tanggal ini!',
            })
        } else {
            preparedData = data.downloadableData;
        }
        let mappedData = [];
        preparedData.forEach(data => {
            mappedData.push({
                ID: data.id,
                KODE_REQUEST: data.requestCode,
                TANGGAL_REQUEST: data.createdDate,
                JENIS_REQUEST: data.requestType,
                KATEGORI: data.requestCategory.name,
                NO_KTP: data.requestData.identityNumber,
                NAMA_LENGKAP: data.requestData.fullName,
                JENIS_KELAMIN: data.requestData.gender,
                AGAMA: data.requestData.religion,
                STATUS_PERKAWINAN: data.requestData.maritalStatus,
                PEKERJAAN: data.requestData.work,
                ALAMAT: data.requestData.identityAddress,
                RT: data.requestData.subDistrict,
                RW: data.requestData.district,
                KEWARGANEGARAAN: data.requestData.nationalism,
                MASA_BERLAKU: data.requestData.identityExpired,
                TEMPAT_LAHIR: checkDataForNull(data.requestOtherData, 'tempatlahir'),
                TANGGAL_LAHIR: checkDataForNull(data.requestOtherData, 'tanggallahir'),
                KELURAHAN: checkDataForNull(data.requestOtherData, 'kaldes'),
                KECAMATAN: checkDataForNull(data.requestOtherData, 'kecamatan'),
                KOTA: checkDataForNull(data.requestOtherData, 'kota'),
                ALAMAT_DOMISISLI: checkDataForNull(data.requestOtherData, 'alamat_domisili'),
                NO_HP: checkDataForNull(data.requestOtherData, 'nomor_handphone'),
            });
            data.requestDocuments.forEach(doc => {
                mappedData.push({
                    NAMA_FILE: doc.filename,
                    KATEGORI_FILE: doc.documentCategory.description,
                })
            })
        })
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        let ws = XLSX.utils.json_to_sheet(mappedData);
        let wb = {Sheets: {'data': ws}, SheetNames: ['data']}
        let excelBuffer = XLSX.write(wb, {bookType: 'xlsx', type: 'array'})
        let exportedData = new Blob([excelBuffer], {type: fileType});
        FileSaver.saveAs(exportedData, 'KLG_' + new Date().toString().split('GMT')[0] + '.xlsx');
    }

    const checkDataForNull = (object, key) => {
        return object.filter(r => r.key === key).length > 0 ? object.filter(r => r.key === key)[0].value : '-'
    }

    return (
        <div className="container">
            <ModalApproval show={data.approvalModal}/>
            <div className="approval-container">
                <div className="page-title">Pengajuan</div>
                <div className="line-space"/>
                <div className="approval-card">
                    <div className="approval-header">
                        <div className="header-text">
                            Data Pendaftar
                        </div>
                        <div className="header-search">
                            <FontAwesomeIcon icon={faSearch} color="#BDBDBD"/>
                            <input
                                type="text"
                                className="search-input"
                                value={data.approvalSearch}
                                onChange={(e) => setData({...data, approvalSearch: e.target.value})}
                                onKeyDown={onSearchDaftarPelanggan}/>
                        </div>
                    </div>
                    <div className="line-space"/>
                    <div className="approval-tab-category">
                        {ApprovalTabData.map((item, index) => {
                            return (
                                <div key={index} className={selectedMenu(item.cname)}
                                     onClick={() => changeMenu(item.cname)}>
                                    <div className="h-spacer"/>
                                    <div className="pile-title">{item.title}</div>
                                </div>
                            )
                        })}
                    </div>
                    <div className="line-space"/>
                    <div className="approval-content">
                        {data.content.sort((a, b) => new Date(b.createdDate.split('T')[0]) - new Date(a.createdDate.split('T')[0])).map((item, index) => {
                            return (
                                <div key={item.id}>
                                    <div className="content-header">
                                        <div className="content-header-text">
                                            <div className="content-header-text-left">
                                                <div
                                                    className="content-type">{translateRequestType(item.requestType)}</div>
                                                <div className="content-id">ID : {item.id}</div>
                                            </div>
                                            <div
                                                className="content-assign-date">{item.createdDate.split('T')[0] + ' || ' + item.createdDate.split('T')[1]}</div>
                                        </div>
                                    </div>
                                    <div className="content-detail">
                                        <div>{loginState.userType === 'pelayanan' ? 'NIK : ' + item.requestData.identityNumber : 'REQUEST : ' + item.requestCode}</div>
                                        <div>{item.requestData.fullName}</div>
                                        <div>{item.requestCategory.name}</div>
                                        <div>Status : <strong>{translateRequestStatus(item.requestStatus.name)}</strong>
                                        </div>
                                    </div>
                                    <div className="content-attachment">
                                        {item.requestDocuments.map((document, index) => {
                                            return (
                                                <div key={document.id} className="attachment-card"
                                                     onClick={() => onClickDocument(document.filename)}>
                                                    <img src={img} alt="img"/>
                                                    <div className="h-spacer"/>
                                                    {document.documentCategory.name}
                                                </div>
                                            )
                                        })}
                                        <div className="approval-action">
                                            <div className="approval-accept" onClick={() => {
                                                action(item)
                                            }}>Ubah Status
                                            </div>
                                        </div>
                                    </div>
                                    <div className="v-spacer"/>
                                    <div className="line-space"/>
                                </div>
                            )
                        })}
                    </div>
                    <div className="approval-bottom-bar">
                        <select className="approval-bottom-filter"
                                value={data.dateFilter}
                                onChange={(e) => {
                                    onChangeDateDownload(e.target.id, e.target.value)
                                }}>
                            {FILTER_INTERVAL.map((item, index) => {
                                return (
                                    <option key={item.value} value={item.value}>{item.name}</option>
                                )
                            })}
                        </select>
                        <div className="h-spacer"/>
                        <div className="approval-bottom-download">
                            <div className="header-download-data" onClick={() => downloadExcel()}>Unduh Data</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Approval;
